import Reservation from '@/modules/reservation/model/Reservation';
import KeyValuePair from '@/modules/core/support/KeyValuePair';

export enum RejectionReason {
    DateNotAvailable = 'DATE_NOT_AVAILABLE',
}
export interface RejectionDetails {
    correlationId: number
    reason: RejectionReason,
    message: string
}

/**
 * Resultado enviado por el servidor al solicita la creación de una lista de reservas
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export class CreateListResult {
    public accepted: Reservation[] = []
    public rejected: RejectionDetails[] = []

    public static deserialize (data: KeyValuePair): CreateListResult {
        return Object.assign(new this(), {
            accepted: data.accepted.map((reservation: KeyValuePair) => Reservation.deserialize(reservation)),
            rejected: data.rejected.map((rejection: KeyValuePair) => ({
                key: rejection.key,
                reason: rejection.reason,
                message: rejection.message,
                correlationId: rejection.correlation_id || null,
            })),
        })
    }
}
